import { render, staticRenderFns } from "./IncomeForm.vue?vue&type=template&id=fe5d2960&"
import script from "./IncomeForm.vue?vue&type=script&lang=js&"
export * from "./IncomeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports